type CatchedErrorConfig = {
    message?: string
    status?: number
    url?: string
    is_cancel?: boolean
}

export class CatchedError {
    message: string | undefined
    status: number | undefined
    url: string | undefined
    is_cancel: boolean | undefined

    constructor({ message, status, url, is_cancel }: CatchedErrorConfig) {
        this.message = message
        this.status = status
        this.url = url
        this.is_cancel = is_cancel
    }

    log(): void {
        console.group('Catched Error')
        console.error('Message: ', this.message)
        console.error('Status: ', this.status)
        console.error('URL: ', this.url)
        console.groupEnd()
    }
}
